<template>
    <div class="join">
        <!-- 图片 -->
        <div class="banner">
            <img src="../assets/img/join/1.png" alt="">
            <h2>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;纸搬客<br>环保公益合伙人</h2>
        </div>
        <!-- 合伙 -->
        <div class="people">
            <div class="people-content">
                <div class="content-left">
                    <img src="../assets/img/home/8.png" alt="">
                    <h3>纸搬客公益回收合伙人</h3>
                    <p>协助纸搬客在已入驻社区完成纸张的收集存放，纸搬客将按照回收重量给予补贴，同时可享受纸搬客一定福利政策，适用于物业保洁人员、社区安保人员、已退休人员，具备一定简易仓储及运输能力，具备公益责任心。
                    </p>
                </div>
                <div class="content-center">
                    <img src="../assets/img/home/9.png" alt="">
                    <h3>纸搬客入驻社区合伙人</h3>
                    <p>协助纸搬客，完成社区的设备入驻，纸搬客将根据社区综合情况给予入驻提成，适用于对当地社区有一定资源的渠道工作者、政府单位合作者，纸搬客将根据您可提供的资源，个性化定制合作方案。
                    </p>
                </div>
                <div class="content-right">
                    <img src="../assets/img/home/10.png" alt="">
                    <h3>纸搬客城市合伙人</h3>
                    <p>纸搬客为服务更多热衷于垃圾回收及环保的用户，采用分公司负责制的管理运营制度，面向全国招募分公司合伙人，如果您在合作城市有一定社会资源，并且热衷于环保公益事业，请与纸搬客联系，纸搬客将根据您的资源情况个性化定制合作方案，协助您在当地建立环保自品牌。
                    </p>
                </div>
            </div>
        </div>
        <!-- 联系我们 -->
        <div class="about">
            <div class="about-content">
                <h2>联系我们</h2>
                <h3 style="margin: 0.03rem 0 0.07rem 0;">Contact Us</h3>
                <div class="content-1">
                    <div class="spe-input">
                        <input type="text" placeholder="填写您的姓名" class="input" v-model="input_1"
                            >
                        <img src="../assets/img/join/5.png" alt="" class="img-1">
                    </div>
                    <div class="spe-input">
                        <input type="text" placeholder="填写您的电话" class="input" oninput="value=value.replace(/[^\d]/g,'')"
                            v-model="input_2" maxlength="11">
                        <img src="../assets/img/join/6.png" alt="" class="img-2">
                    </div>
                    <div class="spe-input">
                        <input type="text" placeholder="填写所在地区及社区" class="input" v-model="input_3"
                           >
                        <img src="../assets/img/join/7.png" alt="" class="img-3">
                    </div>
                    <div class="spe-textarea">
                        <textarea cols="100" rows="100"
                            placeholder="如果您有意向加入纸搬客，请在周一至周五，早九点至下午六点 致电纸搬客客服电话：010-64630081，您也可以通过本页向纸搬客留 言,我们将尽快与您取得联系"
                            class="input-spe" v-model="input_4" ></textarea>
                        <img src="../assets/img/join/8.png" alt="" class="img-4">
                    </div>
                    <div class="btn" @click="submit">提交</div>
                </div>
            </div>
        </div>
        <!-- footer -->
        <footer_s></footer_s>
    </div>
</template>
<script>
    import $ from 'jquery'
    import footer_s from './common/footer'
    export default {
        components: {
            footer_s,
        },
        data() {
            return {
                input_1: '',
                input_2: '',
                input_3: '',
                input_4: '',
            }
        },
        mounted() {
            $(function () {
                $('.banner h2').animate({
                    opacity: 1
                })
                $(window).scroll(function () {
                    var scrollT = $(window).scrollTop(); //滚动的高度
                    var ViewHeight = $(window).height(); //视口的高度
                    var PeopleHeight = $('.people').offset().top; //元素的高度
                    if (scrollT + ViewHeight >= PeopleHeight) {
                        $('.people-content').addClass('animated bounceInUp')
                    }
                })
            })
        },
        methods: {
            /// 提交
            submit() {
                if (this.input_1 == '') {
                    this.Toast({
                        message: "姓名不能为空！",
                        duration: 2000
                    });
                    return false;
                }
                if (this.input_2 == '') {
                    this.Toast({
                        message: "电话号码不能为空！",
                        duration: 2000
                    });
                    return false;
                }
                if (this.input_3 == '') {
                    this.Toast({
                        message: "地区不能为空！",
                        duration: 2000
                    });
                    return false;
                }
                var expressMobile = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/;
                if (!expressMobile.test(this.input_2)) {
                    this.Toast({
                        title: "输入错误",
                        message:
                            "请输入正确的手机号码"
                    });
                } else {
                    var that = this;
                    $.ajax({
                        url: 'https://webservice.paperbanker.com/biz/paperConsultation', //测试地址http://47.92.104.146/
                        // url: 'http://47.92.104.146/biz/paperConsultation', //测试地址http://47.92.104.146/
                        type: "post",
                        data: { name: this.input_1, phone: this.input_2, address: this.input_3, remarks: this.input_4 },
                        dataType: "json",
                        success: function (data) {
                            console.log(data);
                            that.Toast({
                                title: "提示",
                                message: data.message
                            });
                        },
                    })
                }
            },
        },
        beforeDestroy(){
            $(window).off('scroll')
        }
    }
</script>
<style scoped>
    .content-left:hover,
    .content-center:hover,
    .content-right:hover {
        cursor: pointer;
        transform: scale(1.05);
    }

    .join {
        width: 100%;
        height: 100%;
    }

    .banner {
        position: relative;
        height: 1.93rem;
    }

    .banner img {
        width: 100%;
        height: 1.93rem;
    }

    .banner h2 {
        font-size: 0.23rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 0.29rem;
        position: absolute;
        top: 0.61rem;
        left: 1.03rem;
        opacity: 0.3;
    }

    .people {
        width: 100%;
        min-height: 1.36rem;
        background-color: #F5F5F7;
        text-align: center;
        padding: 0.1rem 0;
        overflow: hidden;
    }

    .people-content {
        width: 60%;
        min-height: 1.2rem;
        margin: 0 auto;
        padding-top: 0.06rem;
        background-color: #F5F5F7;
    }

    .people-content img {
        width: 100%;
        height: 0.45rem;
        margin-bottom: 0.075rem;
    }

    .people-content h3 {
        font-size: 0.05rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(55, 55, 55, 1);
        line-height: 0.13rem;
        text-align: center;
    }

    .people-content p {
        font-size: 0.035rem;
        font-family: PingFang SC;
        /* font-weight: bold;*/
        color: rgba(128, 128, 128, 1);
        text-align: center;
        padding: 0 0.04rem;
        line-height: 0.05rem;
    }

    .content-left,
    .content-center,
    .content-right {
        width: 31%;
        min-height: 1.11rem;
        background-color: #ffffff;
        float: left;
        margin-right: 3.5%;
        border-radius: 0.03rem;
        position: relative;
    }

    .content-right {
        margin-right: 0;
    }

    .go {
        width: 0.26rem;
        height: 0.08rem;
        background: rgba(44, 194, 142, 1);
        border-radius: 0.02rem;
        font-size: 0.03rem;
        font-family: PingFang SC;
        text-decoration: underline;
        color: rgba(255, 255, 255, 1);
        line-height: 0.08rem;
        text-align: center;
        margin: 0.05rem auto;
    }

    .about {
        width: 100%;
        height: 1.89rem;
        background-color: #fff;
    }

    .about-content {
        width: 60%;
        height: 1.75rem;
        margin: 0 auto;
        margin-top: 0.09rem;
        background-color: #F5F5F7;
    }

    .about-content h2 {
        font-size: 0.14rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(128, 128, 128, 1);
        line-height: 0.17rem;
        text-align: center;
        padding-top: 0.09rem;
    }

    .about-content h3 {
        font-size: 0.08rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(128, 128, 128, 1);
        line-height: 0.09rem;
        text-align: center;
    }

    .content-1 {
        width: 1.46rem;
        height: 1.27rem;
        margin: 0 auto;
        position: relative;
    }

    .spe-input {
        width: 1.46rem;
        height: 0.15rem;
        margin-bottom: 0.04rem;
        position: relative;
    }

    .input {
        width: 1.46rem;
        height: 0.15rem;
        background-color: #ffffff;
        font-size: 0.04rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(195, 195, 195, 1);
        padding-left: 0.17rem;
        border-radius: 0.02rem;
        display: block;
        /*自带margin-top */
    }

    .spe-textarea {
        width: 1.46rem;
        height: 0.42rem;
        position: relative;
    }

    .input-spe {
        width: 1.46rem;
        height: 0.42rem;
        background-color: #fff;
        font-size: 0.04rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(195, 195, 195, 1);
        line-height: 0.06rem;
        padding: 0.04rem 0.08rem 0 0.17rem;
        border-radius: 0.02rem;
        margin-top: 0.06rem;
        display: block;
    }

    .img-1 {
        width: 0.06rem;
        height: 0.06rem;
        position: absolute;
        top: 50%;
        left: 0.06rem;
        margin-top: -0.03rem;
    }

    .img-2 {
        width: 0.05rem;
        height: 0.06rem;
        position: absolute;
        top: 50%;
        left: 0.06rem;
        margin-top: -0.03rem;
    }

    .img-3 {
        width: 0.04rem;
        height: 0.06rem;
        position: absolute;
        top: 50%;
        left: 0.06rem;
        margin-top: -0.03rem;
    }

    .img-4 {
        width: 0.04rem;
        height: 0.05rem;
        position: absolute;
        top: 11%;
        left: 0.06rem;
        /* margin-top: -0.025rem; */
    }

    .btn {
        width: 0.9rem;
        height: 0.15rem;
        background-color: #39cfa1;
        border-radius: 0.03rem;
        font-size: 0.07rem;
        margin: 0 auto;
        text-align: center;
        line-height: 0.15rem;
        color: #fff;
        margin-top: 0.07rem;
    }
</style>


// WEBPACK FOOTER //
// src/views/join.vue